import {
  ADD_BOOK_STEP,
  ADD_CAR_STEP,
  GET_DEFAULT_STEP,
  MOVE_STEP_1_TO_FINISH,
  MOVE_STEP_1_TO_PROCESS,
  MOVE_STEP_2_TO_FINISH,
  MOVE_STEP_2_TO_PROCESS,
  MOVE_STEP_3_TO_FINISH,
  MOVE_STEP_3_TO_PROCESS,
  MOVE_STEP_4_TO_FINISH,
  MOVE_STEP_4_TO_PROCESS,
  MOVE_STEP_5_TO_FINISH,
  MOVE_STEP_5_TO_PROCESS,
  MOVE_STEP_BOOK_TO_FINISH,
  MOVE_STEP_BOOK_TO_PROCESS,
  MOVE_STEP_CAR_TO_FINISH,
  MOVE_STEP_CAR_TO_PROCESS,
} from './types';

const INITIAL_STATE = {
  step1: {
    title: 'Object Overview',
    status: 'process',
    visible: true,
  },
  step2: {
    title: 'Media',
    status: 'wait',
    visible: true,
  },
  step3: {
    title: 'Location',
    status: 'wait',
    visible: true,
  },
  step4: {
    title: 'Description',
    status: 'wait',
    visible: true,
  },
  step5: {
    title: 'Origin/Publication',
    status: 'wait',
    visible: true,
  },
  step6: {
    title: 'Car Details',
    status: 'wait',
    visible: false,
  },
  step7: {
    title: 'Book Details',
    status: 'wait',
    visible: false,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_DEFAULT_STEP:
      return INITIAL_STATE;
    case ADD_CAR_STEP:
      return {
        ...state,
        step6: {
          title: 'Car Details',
          status: 'wait',
          visible: true,
        },
      };
    case ADD_BOOK_STEP:
      return {
        ...state,
        step7: {
          title: 'Book Details',
          status: 'wait',
          visible: true,
        },
      };
    case MOVE_STEP_1_TO_FINISH:
      return {
        ...state,
        step1: {
          title: 'Object Overview',
          status: 'finish',
          visible: true,
        },
      };
    case MOVE_STEP_1_TO_PROCESS:
      return {
        ...state,
        step1: {
          title: 'Object Overview',
          status: 'process',
          visible: true,
        },
      };
    case MOVE_STEP_2_TO_FINISH:
      return {
        ...state,
        step2: {
          title: 'Media',
          status: 'finish',
          visible: true,
        },
      };
    case MOVE_STEP_2_TO_PROCESS:
      return {
        ...state,
        step2: {
          title: 'Media',
          status: 'process',
          visible: true,
        },
      };
    case MOVE_STEP_3_TO_FINISH:
      return {
        ...state,
        step3: {
          title: 'Location',
          status: 'finish',
          visible: true,
        },
      };
    case MOVE_STEP_3_TO_PROCESS:
      return {
        ...state,
        step3: {
          title: 'Location',
          status: 'process',
          visible: true,
        },
      };
    case MOVE_STEP_4_TO_FINISH:
      return {
        ...state,
        step4: {
          title: 'Description',
          status: 'finish',
          visible: true,
        },
      };
    case MOVE_STEP_4_TO_PROCESS:
      return {
        ...state,
        step4: {
          title: 'Description',
          status: 'process',
          visible: true,
        },
      };
    case MOVE_STEP_5_TO_FINISH:
      return {
        ...state,
        step5: {
          title: 'Origin/Publication',
          status: 'finish',
          visible: true,
        },
      };
    case MOVE_STEP_5_TO_PROCESS:
      return {
        ...state,
        step5: {
          title: 'Origin/Publication',
          status: 'process',
          visible: true,
        },
      };
    case MOVE_STEP_CAR_TO_FINISH:
      return {
        ...state,
        step6: {
          title: 'Car Details',
          status: 'finish',
          visible: true,
        },
      };
    case MOVE_STEP_CAR_TO_PROCESS:
      return {
        ...state,
        step6: {
          title: 'Car Details',
          status: 'process',
          visible: true,
        },
      };
    case MOVE_STEP_BOOK_TO_FINISH:
      return {
        ...state,
        step7: {
          title: 'Book Details',
          status: 'finish',
          visible: true,
        },
      };
    case MOVE_STEP_BOOK_TO_PROCESS:
      return {
        ...state,
        step7: {
          title: 'Book Details',
          status: 'process',
          visible: true,
        },
      };
    default:
      return state;
  }
};
